import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';

/**
 * Get if current user is pending. Throw error if error occurred during the API request.
 * @returns {Promise<boolean>}
 * @throws {Error}
 */
export const userIsPending = async() => {
    const userIsPendingUrl = pathfinder('user_is_pending');

    return axios.get(userIsPendingUrl)
        .then((res) => !!res.data.pending)
        .catch((error) => {
            logger.error(error, {
                msg: 'Error while checking if user is pending',
                url: userIsPendingUrl
            });
            throw error;
        });
};
